export const en = {
    BYN: 'Belarusian Rubles',
    CHF: 'Swiss Francs',
    EUR: 'Euro',
    KZT: 'Kazakhstani Tenge',
    RUB: 'Russian Rubles',
    TRY: 'Turkish Lira',
    UAH: 'Ukranian Hryvnias',
    USD: 'US Dollars',
    UZS: 'Uzbekistani soms',
    currency: 'Currency',
    default: 'none',
    from: 'from',
    prefix: 'Prefix',
    price: 'Price',
    priceOld: 'Old price',
    to: 'under'
};
